

// Populate max height for card-legend
export const updateCardLegendHeight = () => {

    // Sliders
    const cardsWithLegend = Array.from(
        document.querySelectorAll('[data-card-legend=max-fit]')
    );

    cardsWithLegend.forEach(cards => {

        const cardItems = Array.from(
            cards.querySelectorAll('.items .card-legend .card-item')
        );

        // Looking for max height of each item
        let maxHeight = 0;
        cardItems.forEach(card => {
            if( maxHeight < card.offsetHeight){
                maxHeight = card.offsetHeight;
            }
        });

        // Update
        cards.style.setProperty('--nautil-legend-maxheight', maxHeight + 'px');
    });

    // Navigation
    const navWithLegend = Array.from(
        document.querySelectorAll('[data-nav-legend=max-fit]')
    );

    navWithLegend.forEach(cards => {

        const navItems = Array.from(
            cards.querySelectorAll('.items .card-legend')
        );

        // Looking for max height of each item
        let maxHeight = 0;
        navItems.forEach(card => {
            if( maxHeight < card.offsetHeight){
                maxHeight = card.offsetHeight;
            }
        });

        // Update
        cards.style.setProperty('--nautil-legend-maxheight', maxHeight + 'px');
    });

};

// Init
document.addEventListener('DOMContentLoaded', function() {
    requestAnimationFrame(() => {
        setTimeout(() => {
            updateCardLegendHeight();
        }, 50);
    });
});

// Update
/*window.addEventListener('resize', function() {
    updateCardLegendHeight();
});*/
let resizeTimeout;
window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
        updateCardLegendHeight();
    }, 100);
});
